import React, { useEffect , useState } from 'react';

import {
  Card,
  CardHeader ,
  CardBody, 
  CardTitle, 
  CardText, 
  CardSubtitle, 
  Button,
  Container,
  Row,
  Col,
  Input,
  Label,
  Form,
  FormGroup
} from 'reactstrap';


const ContactUsForm = () => {

  return (
    <>
<div>
   
  <p>
     Your enquiry has been successfully submitted!
   </p>

</div>

    </>
  )
}

export default ContactUsForm;
